import locationApi from '@api/locationApi';
import IconLocation from '@assets/icons/location.svg?react';
import ItemList from '@components/itemList';
import LocationTile from '@components/locationTile';
import useCanCreateInTenant from '@hooks/useCanCreateInTenant';
import { useTranslator } from '@i18n';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/profile/locations/')({
  component: LocationList,
});

function LocationList() {
  const t = useTranslator();
  // A location's parent is always an organization, so being an admin of a group alone creates nothing
  const canCreate = useCanCreateInTenant('locations/create');

  return (
    <ItemList
      domain="locations"
      icon={<IconLocation />}
      readonly={!canCreate}
      api={locationApi}
      backButton={{ to: '/profile' }}
      title={t('locations.title')}
      renderItem={(location) => <LocationTile location={location} />}
      availableFilters={['orgId', 'createdOn']}
      // A location belongs to an organization and may be associated with any number of its groups
      orgTypes={['tenant', 'group']}
    />
  );
}
